import { Browser } from '@syncfusion/ej2-base';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation} from '@angular/core';
import { IAccLoadedEventArgs, AccumulationTheme} from '@syncfusion/ej2-angular-charts';

import { LocalStorageKeys, MenuFuncionCodes } from '../../../../../src/app/shared/model';
import { MenuFuncionService, PedidoService } from '../../../../../src/app/shared/services';
import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';
import { Subscription } from 'rxjs';
import { EventEmiterService } from '../../../../../src/app/shared/services/event-emiter.service';

@Component({
  selector: 'app-pedidos-estados',
  templateUrl: './pedidos-estados.component.html',
  styleUrls: ['./pedidos-estados.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class PedidosEstadosComponent implements OnInit {
  canView: boolean = false;
  isValidating: boolean = false;
  isSearching: boolean = false;

  private subscription: Subscription;

  public data:Object[] = [];
  // Initializing Legend
  public legendSettingsPedidoEstado?: Object;
  public tooltipPedidoEstado?: Object;

  // custom code start
  public load(args: IAccLoadedEventArgs): void {
    let selectedTheme: string = location.hash.split('/')[1];
    selectedTheme = selectedTheme ? selectedTheme : 'Material';
    args.accumulation.theme = <AccumulationTheme>(
      (selectedTheme.charAt(0).toUpperCase() +
        selectedTheme.slice(1)).replace(/-dark/i, 'Dark').replace(/contrast/i, 'Contrast')
    );
  }
  // custom code end
  public startAngle: number = Browser.isDevice ? 55 : 35;
  public radius: string = Browser.isDevice ? '60%' : '70%'
  public enableAnimation: boolean = true;

  constructor(
    private menuService: MenuFuncionService,
    private sharedFunctions: SharedFunctions,
    private pedidoService: PedidoService,
    private eventEmitterService: EventEmiterService

    ) {
      this.subscription = this.eventEmitterService.reloadView$.subscribe((value) => {
        this.loadView()
      });
    }

  ngOnInit() {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.DASHBOARD_PEDIDOS_ESTADOS).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result){
        this.canView = true;
        this.loadView();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err);
    });
  }

  loadView() {
    var tenantId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId);
    if (tenantId != null && tenantId.length > 0) {
      this.isSearching = true;
      this.pedidoService.obtenerDashboardPedidosPorEstado().subscribe((response) => {
        this.isSearching = false;
        if (response != null && response.Success) {
          this.legendSettingsPedidoEstado = {
            width: '200', height: '250',shapeHeight: 15, shapeWidth: 15
          };
          this.tooltipPedidoEstado = {
            enable: true
          }

          this.data = response.Result?.Grupos;
        }
      },
      (err: HttpErrorResponse) => {
        this.isSearching = false;
        this.sharedFunctions.handleError(err);
      })
    }
    else {
      setTimeout(() => this.loadView(), 1000);
    }
  }
}
